'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browserInit = undefined;

var _flatten = require('./flatten');

var _flatten2 = _interopRequireDefault(_flatten);

var _maskQuerystring = require('./mask-querystring');

var _maskQuerystring2 = _interopRequireDefault(_maskQuerystring);

var _dontTrack = require('./dont-track');

var _dontTrack2 = _interopRequireDefault(_dontTrack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var integrations = _dontTrack2.default ? {
  All: false,
  Sentry: true
} : {
  All: true
};

var actionHandlers = function actionHandlers(analytics) {
  return {
    PageView: function PageView(_ref) {
      var url = _ref.url,
          _ref$properties = _ref.properties,
          properties = _ref$properties === undefined ? {} : _ref$properties;

      if (url) {
        analytics.page(Object.assign({
          url: (0, _maskQuerystring2.default)(url)
        }, (0, _flatten2.default)(properties)), { integrations: integrations });
      } else {
        throw new Error('Missing url for PageView');
      }
    },

    Event: function Event(_ref2) {
      var id = _ref2.id,
          _ref2$properties = _ref2.properties,
          properties = _ref2$properties === undefined ? {} : _ref2$properties;

      if (id) {
        analytics.track(id, (0, _flatten2.default)(properties), { integrations: integrations });
      } else {
        throw new Error('Missing id for Event');
      }
    },

    Identify: function Identify(_ref3) {
      var userId = _ref3.userId,
          _ref3$traits = _ref3.traits,
          traits = _ref3$traits === undefined ? {} : _ref3$traits;

      if (userId) {
        if (analytics.user().id() == null) {
          // If this is the first time assigning this userId, create
          // an alias from the anonymousId to this userId. This is
          // specifically required for segment/mixpanel integration.
          analytics.alias(userId, { integrations: integrations });
          analytics.identify(userId, traits, { integrations: integrations });
          analytics.track('Established Identity', { integrations: integrations });
        } else {
          analytics.identify(userId, traits, { integrations: integrations });
        }
      } else {
        analytics.identify(traits, { integrations: integrations });
      }
    }
  };
};

var browserInit = exports.browserInit = function browserInit(userActionObservable) {
  if (window.analytics) {
    window.analytics.ready(function () {
      return userActionObservable.subscribe(function (action) {
        var handler = actionHandlers(window.analytics)[action.type];
        if (handler) {
          handler(action);
        }
      });
    });
  } else {
    userActionObservable.subscribe(function (action) {
      return console.log('Segment not initialized, logging action:', action);
    });
  }
};


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/modules/segment.js